import React from 'react'
import { Category } from '../components/categorymenu'

export class AlertsPage extends React.Component {


    render() {
        return (
            <div>
                <Category />
                <div>ALERTS</div>
            </div>
        )
    }
}